import { HttpRequest, HttpEvent, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';

import { environment } from '@env/environment';
import { UserService } from '@app/services/user.service';
import { ToastService } from '@app/services/toast.service';

export const rpcInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const userSrv = inject(UserService);
  const toastSrv = inject(ToastService);

  const hash = userSrv.rpcHash;
  const isApiRPCUrl = req.url.includes(environment.appUrl);

  // Only add Authorization header if request is made to API URL and hash is present
  if (isApiRPCUrl && hash) {
    // Clone request and set Authorization header with the access token
    req = req.clone({
      headers: userSrv.getBasicRpcHeader(),
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401 && isApiRPCUrl) {
        toastSrv.showToast('Unauthorized to RPC! You need to log in.');
        // userSrv.logout();
      }
      return throwError(() => error);
    }),
  );
};
